import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../../common/helpers/helpers";
import TextExpander from "../../../../../../components/TextExpander";

const MolecularProfileColumn = ({ molecularProfile, molecularId, summary }) => {
  const url = molecularId
    ? `https://civicdb.org/molecular-profiles/${molecularId}`
    : null;
  const a = molecularProfile ? (
    <span className="tw-mb-0">
      {url ? (
        <a href={getVarsoUrl(url)} target="_blank">
          {molecularProfile}
        </a>
      ) : (
        <>{molecularProfile}</>
      )}
    </span>
  ) : null;
  const s = summary ? (
    <div className="tw-mb-0">
      <TextExpander text={summary} truncate="150" />
    </div>
  ) : null;
  return (
    <>
      {a}
      {s}
    </>
  );
};

MolecularProfileColumn.propTypes = {
  molecularProfile: PropTypes.string,
  molecularId: PropTypes.number,
  summary: PropTypes.string,
};

MolecularProfileColumn.defaultProps = {
  molecularProfile: null,
  molecularId: null,
  summary: null,
};

export default MolecularProfileColumn;
